import { RootState } from "../../index";

export const getShowGlobalLoader = (state: RootState) =>
  state.appState.showGlobalLoader;
export const getBackUrl = (state: RootState) => state.appState.backUrl;
export const getCurrentSemanticMapId = (state: RootState) =>
  state.appState.currentSemanticMapId;
export const getMissionPlannerData = (state: RootState) =>
  state.appState.missionPlannerData;
export const getActiveTooltipVehicleId = (state: RootState) =>
  state.appState.activeTooltipVehicleId;
